export default "__VITE_ASSET__D0s6uj4f__"